import * as React from "react";
import MobileInfo from "./componets/mobile-info";
import { useOutletContext, useSearchParams } from "react-router-dom";
import WebInfo from "./componets/web-info";
import { useSelector } from "../../../store";

export default function Info() {

	const [handleChangeWebStyleLayout, layout] = useOutletContext();
	const learner = useSelector((state) => state.learner || {});

	const [searchParams] = useSearchParams();

	const testLevelParams = learner?.details?.testLevel || searchParams.get("quizId");


	return (
		<React.Fragment>
			{layout === "mobile" 
				? <MobileInfo />
				: <WebInfo testLevel={testLevelParams} onChangeWebStyleLayout={handleChangeWebStyleLayout}/>
			}
		</React.Fragment>
	);
}
